export default {
  'clocks': [
    'clock0800_1200',
    'clock1200_1600'
  ],
  'permanentRequiredFields': [
    'RequestInterest',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'other': [
      'PostalCode'
    ]
  }
}
